import React, { useEffect, useState } from 'react';
import InformationHeader from '../../../component/reusable/informationHeader/InformationHeader';
import ViewForm from '../../../component/reusable/ViewForm';
import {  useParams } from 'react-router-dom';
import api from '../../../utils/api';
const ViewCategory = () => {

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(null)

  const { id } = useParams()

  const fetchCategoryDetails = async () => {
      setLoading(true)
      try {
          const { data, status } =await api.viewCategory(id)
          
          if (status == 200) {
            setData(data?.data);
          }
      } catch (err) {
          console.log(err);
      } finally {
          setLoading(false)
      }
  }


  useEffect(()=>{
       if(id){
          fetchCategoryDetails()
       } 
  },[id])

  return (
    <div >
      <InformationHeader mainpage="Dashboard" prevpage="Subcategory"  pagename="View Category"/>
      {loading ? <div>Please wait...</div>
        :
        <ViewForm data={data} from={'Category Name*'}/>
      }
    </div>
  );
};

export default ViewCategory;
